import { useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../constants'; // Assuming API_BASE_URL is defined here

const CACHE_STATUS_ENDPOINT = `${API_BASE_URL}/cache-status`; // New endpoint
const LAST_FRONTEND_CACHE_UPDATE_KEY = 'last_frontend_cache_update';
const GENERIC_API_CACHE_PREFIX = 'generic_api_cache_'; // Must match axiosConfig.js

const CacheInvalidator = () => {
  useEffect(() => {
    const checkCacheStatus = async () => {
      try {
        const response = await axios.get(CACHE_STATUS_ENDPOINT);
        const backendTimestamp = response.data.data.timestamp; // Assuming response.data.data.timestamp

        const lastFrontendUpdate = localStorage.getItem(LAST_FRONTEND_CACHE_UPDATE_KEY);

        if (!lastFrontendUpdate || parseInt(lastFrontendUpdate) < backendTimestamp) {
          // Clear all generic API caches
          for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.startsWith(GENERIC_API_CACHE_PREFIX)) {
              localStorage.removeItem(key);
            }
          }
          // Update the frontend cache timestamp
          localStorage.setItem(LAST_FRONTEND_CACHE_UPDATE_KEY, backendTimestamp.toString());
          window.location.reload(); // Reload to fetch fresh data
        }
      } catch (error) {

      }
    };

    checkCacheStatus();
  }, []); // Run once on mount

  return null; // This component doesn't render anything itself
};

export default CacheInvalidator;